var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCorrect = function SvgCorrect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M419.05 824.17a34.88 34.88 0 0 1-22.69-8.36l-313.45-267a35 35 0 0 1 45.39-53.29l287.39 244.8 439.56-493.68a35 35 0 0 1 52.28 46.55L445.2 812.45a34.94 34.94 0 0 1-26.15 11.72"
  })));
};
export default SvgCorrect;